export type BetType = 'inventory' | 'chips';
